import { z } from 'zod';
import { DateTimeSchema, IdSchema } from '../../common';
export const AssessmentReportQuerySchema = z.object({ courseId: IdSchema.optional() });
export const AssessmentReportRowSchema = z.object({
    studentUserId: IdSchema,
    studentName: z.string(),
    courses: z.array(z.object({ id: IdSchema, name: z.string() })),
    status: z.enum(['submitted', 'not_submitted', 'late']),
    correctCount: z.number().int().nonnegative().nullable(),
    wrongCount: z.number().int().nonnegative().nullable(),
    blankCount: z.number().int().nonnegative().nullable(),
    durationSec: z.number().int().nonnegative().nullable(),
    score: z.number().nullable(),
    submittedAt: DateTimeSchema.nullable(),
});
//# sourceMappingURL=report.js.map